import BaseRequest from '../../components/base/base-request';

const getTosUrl = '/termsOfService';
const acceptTosUrl = '/termsOfService/accept';

interface ITosAcceptedResponse {
    id: number;
    username: string;
    fullName?: string;
    phone?: string;
    email?: string;
    address?: string;
    companyId: number;
}

class TosRequests extends BaseRequest {
    public async getTosText(): Promise<string> {
        return this.rawRequest<string>(getTosUrl, null, {
            type: 'GET',
            contentType: 'text/plain',
            bodyParseFormat: 'text'
        });
    }

    public async acceptTos(): Promise<ITosAcceptedResponse> {
        return this.rawRequest<ITosAcceptedResponse>(acceptTosUrl, null, { type: 'POST' });
    }
}

export const tosRequests = new TosRequests();
